import React from 'react';
import PropTypes from 'prop-types';
import { IonItem, IonLabel, IonThumbnail } from '@ionic/react';
import { formatCurrency } from 'utils/currency';

function MenuItem({ item, ...rest }) {
  return (
    <IonItem id={item.id} className="menu-item" button {...rest}>
      <IonLabel className="ion-text-wrap">
        <h2>{item.name}</h2>
        {item.description && <p>{item.description}</p>}
        <p>
          {
            /* item.display_multiple_prices
              ? (item.custom_prices || []).map((p) => formatCurrency(p)).join(' | ') : formatCurrency(item.price_per_unit) */
            formatCurrency(item.price)
          }
        </p>
      </IonLabel>

      {item.image && (
        <IonThumbnail slot="end">
          <img src={item.image} alt={item.name} />
        </IonThumbnail>
      )}
    </IonItem>
  );
}

MenuItem.propTypes = {
  item: PropTypes.object,
};

export default MenuItem;
